export default __webpack_public_path__ + "maps-examples-draggable-views-thumbnail-480-96deac2a436931818da197022bbb0087.png";